import React, { useEffect, useState } from 'react';
import axios from 'axios';
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import ErrorPopup from './popup/ErrorPopup';

export const SerachDisplayDiv = ({ ai_response, set_ai_response, setError, error, isLoading, setIsLoading }) => {
  const [errPopupVisible, setErrorPopupVisible] = useState(false)
  const [lastError, setLastError] = useState(null)
  const contentRef = React.useRef(null)

  useEffect(() => {
    // Show popup only when error changes from null to something or changes to a different error
    if (error !== null && error !== '' && error !== lastError) {
      setErrorPopupVisible(true)
      setLastError(error)
    } else if (error === null || error === '') {
      setErrorPopupVisible(false)
      setLastError(null)
    }
  }, [error, lastError])

  // Auto-scroll to bottom when response updates
  useEffect(() => {
    if (contentRef.current && ai_response) {
      contentRef.current.scrollTop = contentRef.current.scrollHeight
    }
  }, [ai_response])

  const handleClosePopup = () => {
    setErrorPopupVisible(false)
  }
  
  const handleCloseAll = () => {
    setError(null)
    set_ai_response('')
    setIsLoading(false)
    setErrorPopupVisible(false)
  }
  
  return (<>
    <div 
      ref={contentRef}
      className='ev-message-card2 d-block ev-card-2 notification-dropdown-menu position-fixed top-7 left-17 w-45 vh-35 p-0' 
      style={{ zIndex: 10000 }}
    >
      <div className="d-flex justify-content-end">
        <button
          className="ev-btn-text-only-fill ev-btn-med pe-3 pt-2"
          onClick={handleCloseAll}>
          <i className='bi bi-x-circle'></i>
        </button>
      </div>
      {ai_response === '' && isLoading ? (
        <div className="d-flex justify-content-center margin-top-10">
          <img
            src="media/loader2.svg"
            className="w-10"
            alt="Loading"
          />
        </div>
      ) : (errPopupVisible ? (<>
        <ErrorPopup onClose={handleClosePopup} message={error} />
      </>) : (<>
        <div>
          <label className="ev-message-card2 ev-btn-small ev-radius-large ms-3 mb-2"><i class="bi bi-robot"></i> Support Assistant</label>
          <div className='markdown-justified scrollable-element vh-25 ev-padding-med pt-0'>
            <ReactMarkdown remarkPlugins={[remarkGfm]} className='ev-small-p-dark'>
              {ai_response}
            </ReactMarkdown>
          </div>
        </div>
      </>))}
    </div>
  </>)
};

const AiSearchComponent = ({ tok, where_user, ai_response, setResponse, isLoading, setIsLoading, setError }) => {
  const [question, setQuestion] = useState('');
  const prefix = '/pceapi/general'
  
  // Streaming effect: Display text character by character
  const streamText = async (text) => {
    const words = text.split(' ');
    
    for (let i = 0; i < words.length; i++) {
      setResponse(prev => prev + (prev ? ' ' : '') + words[i]);
      // Adjust delay for faster/slower streaming (10-30ms recommended)
      await new Promise(resolve => setTimeout(resolve, 15));
    }
  };

  const handleSearch = async (e) => {
    if (e) e.preventDefault();
    if (!question.trim()) return;

    // Reset state for new search
    setIsLoading(true);
    setError(null);
    setResponse('');

    try {
      const req_body = {
        user_guide: where_user,
        question: question,
      };

      const response = await fetch(`${process.env.REACT_APP_API_URL || ''}${prefix}/chat-guide`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: tok,
        },
        body: JSON.stringify(req_body),
      });
      
      if (!response.ok) {
        setError(`Server Error: ${response.status}`)
        setIsLoading(false);
        return;
      }
      
      const reader = response.body.getReader();
      const decoder = new TextDecoder()
      let buff = '';
      let accumulatedText = '';

      while (true) {
        const { done, value } = await reader.read()
        if (done) break;

        buff += decoder.decode(value, { stream: true });
        const lines = buff.split('\n');
        buff = lines.pop() || '';

        for (const line of lines) {
          if (line.trim() === '') continue;
          
          // Try to parse as JSON first (for error handling)
          let isError = false;
          try {
            const data = JSON.parse(line);
            if ((data.type && data.type === 'error') || (data.status && data.status === 'error')) {
              setError(`${data.message}`)
              setIsLoading(false)
              return;
            }
            // If it's JSON but not an error, it might still be valid content
            // Don't mark as error, continue processing
          } catch (parseError) {
            // Not JSON, treat as markdown text - this is the normal case
            accumulatedText += line + '\n';
          }
        }
        
        // Stream the accumulated text so far
        if (accumulatedText) {
          await streamText(accumulatedText);
          accumulatedText = ''; // Clear after streaming
        }
      }
      
      // Stream any remaining buffered content
      if (buff.trim()) {
        await streamText(buff);
      }
      
    } catch (err) {
      setError("Request Fetch Failed");
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div className="w-100 mx-auto" >
      <form className='d-flex'>
        <input
          className='formField2 nav-search-bar ms-0 pe-5'
          value={question}
          onChange={(e) => setQuestion(e.target.value)}
          onKeyPress={(e) => e.key === 'Enter' && handleSearch(e)}
          placeholder="Ask me anything about using the console"
          disabled={isLoading}
        />
        <button
          type='submit'
          onClick={handleSearch}
          disabled={isLoading || !question.trim()}
          className='ev-btn-text-only-fill ev-btn-med nav-search-button'
        >
          <i className="bi bi-search"></i>
        </button>
      </form>
    </div>
  );
};

export default AiSearchComponent;